import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/ExpertConnect.module.css';

import accountantImg from '../../assets/images/이홍승회계사님.png';
import laborAttorneyImg from '../../assets/images/박찬재노무사님.jpg';
import lawyerImg from '../../assets/images/최수영변호사님.jpg';

const experts = [
  {
    name: '이홍승',
    role: '회계사',
    specialties: ['세금 신고', '절세 전략', '부가세 처리'],
    image: accountantImg
  },
  {
    name: '박찬재',
    role: '노무사',
    specialties: ['코치 고용계약', '4대보험 문의', '급여 체계 설계'],
    image: laborAttorneyImg
  },
  {
    name: '최수영',
    role: '변호사',
    specialties: ['계약서 검토', '회원 분쟁', '법률 자문'],
    image: lawyerImg
  }
];

export default function ExpertConnect() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="expert-connect" ref={ref} className={`section ${styles.expertConnect}`}>
      <div className="section-content">
        <h2 className="text-center">경영 고민까지, 전문가에게 자동 연결</h2>
        <p className={`${styles.subtitle} text-center`}>
          대기업엔 경영지원팀이 있습니다. 이제 우리 센터에도.
        </p>

        <div className={`${styles.experts} ${isVisible ? styles.visible : ''}`}>
          {experts.map((expert, index) => (
            <div
              key={index}
              className={styles.expertCard}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className={styles.expertAvatar}>
                <img src={expert.image} alt={`${expert.name} ${expert.role}`} />
              </div>
              <h3 className={styles.expertName}>{expert.name} <span>{expert.role}</span></h3>
              <ul className={styles.services}>
                {expert.specialties.map((specialty, i) => (
                  <li key={i}>{specialty}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
